import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BtnLng from '~/commons/components/btns/BtnLng';
import env from '~/commons/config/env';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import Footer from './Footer';

const Header = () => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const th = (h) => t(`nav.${h}`, h);

  return (
    <header>
      <div className="container d-flex d-md-block">
        {/* mobile menu toggle */}
        <button
          type="button"
          className="btn d-inline-block d-md-none py-3"
          onClick={() => setShow(!show)}
        >
          <img
            src="/assets/img/menu-toggle.png"
            alt="Menu toggle"
            style={{ width: '1.5rem' }}
          />
        </button>
        {/* backdrop */}
        <div
          className={`
            ${show ? 'd-block d-md-none' : 'd-none'}
            anim-fade-in position-fixed
            top-0 start-0 vw-100 vh-100
          `}
          style={{
            backgroundColor: 'rgba(255, 255, 255, .6)',
            zIndex: 999,
          }}
          onClick={() => setShow(false)}
        />
        {/* nav */}
        <nav
          className={`
            main-nav justify-content-between
            pt-5 pt-md-0
            d-flex d-md-flex flex-md-row
            ${show ? 'flex-column' : 'd-none'}
          `}
        >
          {/* close button */}
          <button
            type="button"
            className={`
              position-absolute top-0 end-0
              btn w-auto d-block d-md-none
            `}
            onClick={() => setShow(false)}
          >
            <FA icon={faTimes} size="lg" />
          </button>
          {env.user?.role !== 'client' ? (
            <>
              <NavLink to="/">
                {th('Homepage')}
              </NavLink>
              <NavLink to="/topics">
                {th('TopicIntro')}
              </NavLink>
              <NavLink to="/mascots">
                {th('MascotIntro')}
              </NavLink>
              <NavLink to="/links">
                {th('Links')}
              </NavLink>
              <div className="btn-lng d-none d-md-block">
                <BtnLng className="" />
              </div>
            </>
          ) : (
            <>
              <NavLink to="/game">
                {th('Homepage')}
              </NavLink>
              <NavLink to="/game/profile">
                {th('Profile')}
              </NavLink>
              <NavLink to="/game/rankings">
                {th('Rankings')}
              </NavLink>
              <div className="btn-lng d-none d-md-block">
                <BtnLng className="" />
              </div>
              <div className="flex-fill d-none d-md-block" />
            </>
          )}

          {env.user ? (
            <a href="/logout">
              {th('Logout')}
            </a>
          ) : (
            <NavLink to="/auth">
              {th('Login')}
            </NavLink>
          )}

          <div className="d-block d-md-none flex-fill p-0" />
          <div className="m-footer d-flex d-md-none d-none flex-column p-0 py-3">
            <Footer linksOnly />
          </div>
        </nav>
        <div className="d-md-none py-3 ms-auto">
          <div className="btn-lng">
            <BtnLng className="" />
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
